module.exports = __webpack_public_path__ + "static/media/win-1.fe387a49.png";